import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
} from "./actionTypes"

interface ForgetPasswordState {
  forgetSuccessMsg: string | null;
  forgetError: string | null;
}

interface ForgetPasswordAction {
  type: string;
  payload?: any;
}

const initialState: ForgetPasswordState = {
  forgetSuccessMsg: null,
  forgetError: null,
}

const forgetPassword = (state: ForgetPasswordState = initialState, action: ForgetPasswordAction): ForgetPasswordState => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
